
export type ZoomConfig = {
    printzoom?: string[];
    minzoom?: number;
    maxzoom?: number;
}

/* ******************:
 *  printzoomが全て違う値か判定する関数
 * ********************/
export const areAllPrintZoomValuesUnique = (obj: { [key: string]: ZoomConfig }): boolean => {
    const printZoomArrs = Object.values(obj)
        .map(item => item.printzoom)
        .filter((pz): pz is string[] => Array.isArray(pz) && pz.length > 0);

    if (printZoomArrs.length <= 1) return false;

    for (let i = 0; i < printZoomArrs.length; i++) {
        for (let j = i + 1; j < printZoomArrs.length; j++) {
            const a = printZoomArrs[i];
            const b = printZoomArrs[j];
            // 完全一致または一方が他方をすべて含む場合
            if (
                a.length === b.length && a.every((v, idx) => v === b[idx]) ||
                a.every(v => b.includes(v)) ||
                b.every(v => a.includes(v))
            ) {
                return false;
            }
        }
    }
    return true;
};

/* ******************:
 * minzoom、maxzoom、printzoomの範囲が重ならないか、またはそれぞれの範囲が異なるかどうかを確認する関数
 * ********************/
export const checkZoomRanges = (obj: { [key: string]: ZoomConfig }, measure: { label: string, value: number }[]): boolean => {
    const zoomRanges = Object.values(obj).map(item => ({
      minzoom: item.minzoom ?? -Infinity,
      maxzoom: item.maxzoom ?? Infinity,
      printzoom: item.printzoom
    }));
  
    for (let i = 0; i < zoomRanges.length; i++) {
      for (let j = i + 1; j < zoomRanges.length; j++) {
        const rangeA = zoomRanges[i];
        const rangeB = zoomRanges[j];

        // printzoomの値をlabelからvalueに変換
        const printZoomValuesA = rangeA.printzoom?.map(label => measure.find((val) => val.label === label)?.value);
        const printZoomValuesB = rangeB.printzoom?.map(label => measure.find((val) => val.label === label)?.value);

  
        // 範囲が重ならないかを確認
        if (rangeA.maxzoom < rangeB.minzoom || rangeB.maxzoom < rangeA.minzoom) {
          return true;
        }

        // printzoomの値が範囲外かを確認
        if (printZoomValuesA?.some(value => (value && value < rangeB.minzoom) || (value && value > rangeB.maxzoom)) ||
            printZoomValuesB?.some(value => (value && value < rangeA.minzoom) || (value && value > rangeA.maxzoom))) {
          return true;
        }

      }
    }
  
    return false;
};
